var _defs, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 204 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "77.548%",
    y1: "2.458%",
    x2: "21.932%",
    y2: "86.628%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0A8D4",
    offset: "58%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8791C7",
    offset: "73%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6470B4",
    offset: "91%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "22.429%",
    y1: "97.542%",
    x2: "78.068%",
    y2: "13.372%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0A8D4",
    offset: "58%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8791C7",
    offset: "73%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6470B4",
    offset: "91%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.997%",
    y1: "-.494%",
    x2: "49.997%",
    y2: "100.309%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#513EFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5157FF",
    offset: "18%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5298FF",
    offset: "57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52E5FF",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 60.81V18.93a.22.22 0 0 1 .21-.2h26.61a.22.22 0 0 1 .22.22v5.33a.22.22 0 0 1-.22.22h-20.4v12.34h17.35a.22.22 0 0 1 .22.22v5.27a.22.22 0 0 1-.22.22H96.42v12.71h20.4a.22.22 0 0 1 .22.22v5.33a.22.22 0 0 1-.22.22H90.21a.22.22 0 0 1-.21-.22Zm66.17.11L136.7 31.27V60.8a.22.22 0 0 1-.22.22h-6a.22.22 0 0 1-.22-.22V18.96a.22.22 0 0 1 .22-.22h5.55a.22.22 0 0 1 .18.1l19.49 29.59V18.96a.22.22 0 0 1 .22-.22h6a.22.22 0 0 1 .22.22V60.8a.22.22 0 0 1-.22.22h-5.57a.22.22 0 0 1-.18-.1Zm25.6-8.02v2c2.57.558 5.19.866 7.82.92a40.27 40.27 0 0 0 7.73-.91v-9.48l-21.78-7.61a.22.22 0 0 1-.14-.2V20.21a.19.19 0 0 1 .14-.2 54.34 54.34 0 0 1 13.94-2 55.07 55.07 0 0 1 14 2 .19.19 0 0 1 .14.2v6.57a.22.22 0 0 1-.22.22h-5.89a.22.22 0 0 1-.22-.22v-2a40.85 40.85 0 0 0-7.82-.91 40.5 40.5 0 0 0-7.73.9l.03 8.96 21.7 7.6a.22.22 0 0 1 .14.2v17.95a.19.19 0 0 1-.14.2 54.36 54.36 0 0 1-13.94 2 55.11 55.11 0 0 1-14-2 .19.19 0 0 1-.14-.2V52.9a.22.22 0 0 1 .22-.22h5.88a.22.22 0 0 1 .28.22Z",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.325 32.75c.8 1.71 2.78 5.09 2.78 5.09L34.995 0l-22.34 15.6a9.75 9.75 0 0 0-3.18 3.5 16.19 16.19 0 0 0-.15 13.65Z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M.255 45.21a25.47 25.47 0 0 0 10 18.51l24.71 17.23s-15.46-22.28-28.5-44.45a22.39 22.39 0 0 1-2.62-7.56 12.1 12.1 0 0 1 0-3.63c-.34.63-1 1.92-1 1.92a29.35 29.35 0 0 0-2.67 8.55 52.28 52.28 0 0 0 .08 9.43Z",
    fill: "#A0A8D4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.295 48.2c-.8-1.71-2.78-5.09-2.78-5.09l-22.89 37.84 22.34-15.59a9.75 9.75 0 0 0 3.18-3.5 16.19 16.19 0 0 0 .15-13.66Z",
    fill: "url(#b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.365 35.74a25.47 25.47 0 0 0-10-18.51L37.655 0s15.45 22.28 28.5 44.45a22.39 22.39 0 0 1 2.61 7.56 12.1 12.1 0 0 1 0 3.63c.34-.63 1-1.92 1-1.92a29.35 29.35 0 0 0 2.67-8.55 52.28 52.28 0 0 0-.07-9.43Z",
    fill: "#A0A8D4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.475 19.1a9.75 9.75 0 0 1 3.18-3.5L34.995 0l-22.89 37.85s-2-3.38-2.78-5.09a16.19 16.19 0 0 1 .15-13.66ZM.255 45.21a25.47 25.47 0 0 0 10 18.51l24.71 17.23s-15.46-22.28-28.5-44.45a22.39 22.39 0 0 1-2.62-7.56 12.1 12.1 0 0 1 0-3.63c-.34.63-1 1.92-1 1.92a29.35 29.35 0 0 0-2.67 8.55 52.28 52.28 0 0 0 .08 9.43Zm63 3c-.8-1.71-2.78-5.09-2.78-5.09l-22.85 37.83 22.34-15.59a9.75 9.75 0 0 0 3.18-3.5 16.19 16.19 0 0 0 .15-13.66l-.04.01Zm9.07-12.46a25.47 25.47 0 0 0-10-18.51L37.655 0s15.45 22.28 28.5 44.45a22.39 22.39 0 0 1 2.61 7.56 12.1 12.1 0 0 1 0 3.63c.34-.63 1-1.92 1-1.92a29.35 29.35 0 0 0 2.67-8.55 52.28 52.28 0 0 0-.07-9.43l-.04.01Z",
    fill: "url(#c)",
    style: {
      mixBlendMode: "color"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnsLogo);
export default __webpack_public_path__ + "static/media/ENS-logo.c62018975671eb774943fc547d3c0846.svg";
export { ForwardRef as ReactComponent };